import request from '@/utils/request'

// 分页查询检测项目
export function getInspectionItemList(params) {
  return request({
    url: '/api/admin/inspection-item/list',
    method: 'get',
    params
  })
}

// 根据报告ID获取检测项目列表
export function getInspectionItemsByReport(reportId) {
  return request({
    url: '/api/admin/inspection-item/by-report',
    method: 'get',
    params: { reportId }
  })
}

// 添加检测项目
export function addInspectionItem(data) {
  return request({
    url: '/api/admin/inspection-item/add',
    method: 'post',
    data
  })
}

// 更新检测项目
export function updateInspectionItem(data) {
  return request({
    url: '/api/admin/inspection-item/update',
    method: 'post',
    data
  })
}

// 删除检测项目
export function deleteInspectionItem(id) {
  return request({
    url: '/api/admin/inspection-item/delete',
    method: 'post',
    params: { id }
  })
}

// 获取报告列表选项
export function getReportOptions(vehicleId) {
  return request({
    url: '/api/admin/inspection-item/report-options',
    method: 'get',
    params: { vehicleId }
  })
}

// 获取检测项模板列表
export function getTemplateOptions() {
  return request({
    url: '/api/admin/inspection-item/template-options',
    method: 'get'
  })
}

// 批量更新检测项目
export function batchUpdateInspectionItems(data) {
  return request({
    url: '/api/admin/inspection-item/batch-update',
    method: 'post',
    data
  })
}

// 获取检测项目选项列表（用于选择框）
export function getInspectionItemOptions() {
  return request({
    url: '/api/admin/inspection-item/options',
    method: 'get'
  })
}

// 根据车辆ID获取检测项目选项列表
export function getInspectionItemOptionsByVehicle(vehicleId) {
  return request({
    url: '/api/admin/inspection-item/options-by-vehicle',
    method: 'get',
    params: { vehicleId }
  })
} 